export default "__VITE_ASSET__BiNUbGF0__"